//node_modules
import React, { FunctionComponent, PropsWithChildren } from "react";
import { Button, Spinner } from "react-bootstrap";

type SubmitProps = {
  submitting: boolean;
  className?: string;
  size?: "sm" | "lg";
  variant?: string;
  disabled?: boolean;
  onClick?: () => void;
};

const SubmitButton: FunctionComponent<PropsWithChildren<SubmitProps>> = ({ submitting, className, variant, size, disabled, onClick, children }) => {
  if (submitting) {
    return (
      <Button size={size} className={className} variant={variant} disabled>
        <Spinner as="span" className="mx-4" animation="border" size="sm" role="status" aria-hidden="true" />
      </Button>
    );
  } else {
    return (
      <Button type="submit" className={className} size={size} variant={variant} onClick={onClick} disabled={disabled}>
        {children}
      </Button>
    );
  }
};

export default SubmitButton;
